import y from "../../../../public/projects/kasturi/projects/y.jpg";
import s from "../../../../public/projects/kasturi/logo/s.png";
import evergreen from "../../../../public/projects/kasturi/projects/ev.jpg"

// eonhomes
import overviewImageeonhomes from "../../../../public/projects/kasturi/eonhomes/overview/1.webp";
import bannerDesktopImageeonhomes from "../../../../public/projects/kasturi/eonhomes/banner/1.webp";
import bannerMobileImageeonhomes from "../../../../public/projects/kasturi/eonhomes/banner/2.webp";
import Locationeonhomes from "../../../../public/projects/kasturi/eonhomes/location/1.webp";
import Hightlightseonhomes from "../../../../public/projects/kasturi/eonhomes/highlights/1.webp";
import floorplan1eonhomes from "../../../../public/projects/kasturi/eonhomes/floorplan/1.webp";
import floorplan2eonhomes from "../../../../public/projects/kasturi/eonhomes/floorplan/2.webp";
import floorplan3eonhomes from "../../../../public/projects/kasturi/eonhomes/floorplan/3.webp";
import floorplan4eonhomes from "../../../../public/projects/kasturi/eonhomes/floorplan/4.webp";
import floorplan5eonhomes from "../../../../public/projects/kasturi/eonhomes/floorplan/5.webp";
import locationiconeonhomes from "../../../../public/projects/kasturi/eonhomes/overview/l.png";
import caliconeonhomes from "../../../../public/projects/kasturi/eonhomes/overview/c.png";
import newlaunchiconeonhomes from "../../../../public/projects/kasturi/eonhomes/overview/n.png";
import gallery1eonhomes from "../../../../public/projects/kasturi/eonhomes/gallery/1.webp";
import gallery2eonhomes from "../../../../public/projects/kasturi/eonhomes/gallery/2.webp";
import gallery3eonhomes from "../../../../public/projects/kasturi/eonhomes/gallery/3.webp";
import gallery4eonhomes from "../../../../public/projects/kasturi/eonhomes/gallery/4.webp";
import gallery5eonhomes from "../../../../public/projects/kasturi/eonhomes/gallery/5.webp";

// projecttwo
import overviewImageprojecttwo from "../../../../public/projects/kasturi/projecttwo/overview/1.webp";
import bannerDesktopImageprojecttwo from "../../../../public/projects/kasturi/projecttwo/banner/1.webp";
import bannerMobileImageprojecttwo from "../../../../public/projects/kasturi/projecttwo/banner/2.webp";
import Locationprojecttwo from "../../../../public/projects/kasturi/projecttwo/location/1.webp";
import Hightlightsprojecttwo from "../../../../public/projects/kasturi/projecttwo/highlights/1.webp";
import floorplan1projecttwo from "../../../../public/projects/kasturi/projecttwo/floorplan/1.webp";
import floorplan2projecttwo from "../../../../public/projects/kasturi/projecttwo/floorplan/2.webp";
import floorplan3projecttwo from "../../../../public/projects/kasturi/projecttwo/floorplan/3.webp";
import floorplan4projecttwo from "../../../../public/projects/kasturi/projecttwo/floorplan/4.webp";
import floorplan5projecttwo from "../../../../public/projects/kasturi/projecttwo/floorplan/5.webp";
import locationiconprojecttwo from "../../../../public/projects/kasturi/projecttwo/overview/l.png";
import caliconprojecttwo from "../../../../public/projects/kasturi/projecttwo/overview/c.png";
import newlaunchiconprojecttwo from "../../../../public/projects/kasturi/projecttwo/overview/n.png";
import gallery1projecttwo from "../../../../public/projects/kasturi/projecttwo/gallery/1.webp";
import gallery2projecttwo from "../../../../public/projects/kasturi/projecttwo/gallery/2.webp";
import gallery3projecttwo from "../../../../public/projects/kasturi/projecttwo/gallery/3.webp";
import gallery4projecttwo from "../../../../public/projects/kasturi/projecttwo/gallery/4.webp";
import gallery5projecttwo from "../../../../public/projects/kasturi/projecttwo/gallery/5.webp";

// projectthree
import overviewImageprojectthree from "../../../../public/projects/kasturi/projectthree/overview/1.webp";
import bannerDesktopImageprojectthree from "../../../../public/projects/kasturi/projectthree/banner/1.webp";
import bannerMobileImageprojectthree from "../../../../public/projects/kasturi/projectthree/banner/2.webp";
import Locationprojectthree from "../../../../public/projects/kasturi/projectthree/location/1.webp";
import Hightlightsprojectthree from "../../../../public/projects/kasturi/projectthree/highlights/1.webp";
import floorplan1projectthree from "../../../../public/projects/kasturi/projectthree/floorplan/1.webp";
import floorplan2projectthree from "../../../../public/projects/kasturi/projectthree/floorplan/2.webp";
import floorplan3projectthree from "../../../../public/projects/kasturi/projectthree/floorplan/3.webp";
import floorplan4projectthree from "../../../../public/projects/kasturi/projectthree/floorplan/4.webp";
import floorplan5projectthree from "../../../../public/projects/kasturi/projectthree/floorplan/5.webp";
import locationiconprojectthree from "../../../../public/projects/kasturi/projectthree/overview/l.png";
import caliconprojectthree from "../../../../public/projects/kasturi/projectthree/overview/c.png";
import newlaunchiconprojectthree from "../../../../public/projects/kasturi/projectthree/overview/n.png";
import gallery1projectthree from "../../../../public/projects/kasturi/projectthree/gallery/1.webp";
import gallery2projectthree from "../../../../public/projects/kasturi/projectthree/gallery/2.webp";
import gallery3projectthree from "../../../../public/projects/kasturi/projectthree/gallery/3.webp";
import gallery4projectthree from "../../../../public/projects/kasturi/projectthree/gallery/4.webp";
import gallery5projectthree from "../../../../public/projects/kasturi/projectthree/gallery/5.webp";

// projectfour
import overviewImageprojectfour from "../../../../public/projects/kasturi/projectfour/overview/1.webp";
import bannerDesktopImageprojectfour from "../../../../public/projects/kasturi/projectfour/banner/1.webp";
import bannerMobileImageprojectfour from "../../../../public/projects/kasturi/projectfour/banner/2.webp";
import Locationprojectfour from "../../../../public/projects/kasturi/projectfour/location/1.webp";
import Hightlightsprojectfour from "../../../../public/projects/kasturi/projectfour/highlights/1.webp";
import floorplan1projectfour from "../../../../public/projects/kasturi/projectfour/floorplan/1.webp";
import floorplan2projectfour from "../../../../public/projects/kasturi/projectfour/floorplan/2.webp";
import floorplan3projectfour from "../../../../public/projects/kasturi/projectfour/floorplan/3.webp";
import floorplan4projectfour from "../../../../public/projects/kasturi/projectfour/floorplan/4.webp";
import floorplan5projectfour from "../../../../public/projects/kasturi/projectfour/floorplan/5.webp";
import locationiconprojectfour from "../../../../public/projects/kasturi/projectfour/overview/l.png";
import caliconprojectfour from "../../../../public/projects/kasturi/projectfour/overview/c.png";
import newlaunchiconprojectfour from "../../../../public/projects/kasturi/projectfour/overview/n.png";
import gallery1projectfour from "../../../../public/projects/kasturi/projectfour/gallery/1.webp";
import gallery2projectfour from "../../../../public/projects/kasturi/projectfour/gallery/2.webp";
import gallery3projectfour from "../../../../public/projects/kasturi/projectfour/gallery/3.webp";
import gallery4projectfour from "../../../../public/projects/kasturi/projectfour/gallery/4.webp";
import gallery5projectfour from "../../../../public/projects/kasturi/projectfour/gallery/5.webp";

// projectfive
import overviewImageprojectfive from "../../../../public/projects/kasturi/projectfive/overview/1.webp";
import bannerDesktopImageprojectfive from "../../../../public/projects/kasturi/projectfive/banner/1.webp";
import bannerMobileImageprojectfive from "../../../../public/projects/kasturi/projectfive/banner/2.webp";
import Locationprojectfive from "../../../../public/projects/kasturi/projectfive/location/1.webp";
import Hightlightsprojectfive from "../../../../public/projects/kasturi/projectfive/highlights/1.webp";
import floorplan1projectfive from "../../../../public/projects/kasturi/projectfive/floorplan/1.webp";
import floorplan2projectfive from "../../../../public/projects/kasturi/projectfive/floorplan/2.webp";
import floorplan3projectfive from "../../../../public/projects/kasturi/projectfive/floorplan/3.webp";
import floorplan4projectfive from "../../../../public/projects/kasturi/projectfive/floorplan/4.webp";
import floorplan5projectfive from "../../../../public/projects/kasturi/projectfive/floorplan/5.webp";
import locationiconprojectfive from "../../../../public/projects/kasturi/projectfive/overview/l.png";
import caliconprojectfive from "../../../../public/projects/kasturi/projectfive/overview/c.png";
import newlaunchiconprojectfive from "../../../../public/projects/kasturi/projectfive/overview/n.png";
import gallery1projectfive from "../../../../public/projects/kasturi/projectfive/gallery/1.webp";
import gallery2projectfive from "../../../../public/projects/kasturi/projectfive/gallery/2.webp";
import gallery3projectfive from "../../../../public/projects/kasturi/projectfive/gallery/3.webp";
import gallery4projectfive from "../../../../public/projects/kasturi/projectfive/gallery/4.webp";
import gallery5projectfive from "../../../../public/projects/kasturi/projectfive/gallery/5.webp";

// projectsix
import overviewImageprojectsix from "../../../../public/projects/kasturi/projectsix/overview/1.webp";
import bannerDesktopImageprojectsix from "../../../../public/projects/kasturi/projectsix/banner/1.webp";
import bannerMobileImageprojectsix from "../../../../public/projects/kasturi/projectsix/banner/2.webp";
import Locationprojectsix from "../../../../public/projects/kasturi/projectsix/location/1.webp";
import Hightlightsprojectsix from "../../../../public/projects/kasturi/projectsix/highlights/1.webp";
import floorplan1projectsix from "../../../../public/projects/kasturi/projectsix/floorplan/1.webp";
import floorplan2projectsix from "../../../../public/projects/kasturi/projectsix/floorplan/2.webp";
import floorplan3projectsix from "../../../../public/projects/kasturi/projectsix/floorplan/3.webp";
import floorplan4projectsix from "../../../../public/projects/kasturi/projectsix/floorplan/4.webp";
import floorplan5projectsix from "../../../../public/projects/kasturi/projectsix/floorplan/5.webp";
import locationiconprojectsix from "../../../../public/projects/kasturi/projectsix/overview/l.png";
import caliconprojectsix from "../../../../public/projects/kasturi/projectsix/overview/c.png";
import newlaunchiconprojectsix from "../../../../public/projects/kasturi/projectsix/overview/n.png";
import gallery1projectsix from "../../../../public/projects/kasturi/projectsix/gallery/1.webp";
import gallery2projectsix from "../../../../public/projects/kasturi/projectsix/gallery/2.webp";
import gallery3projectsix from "../../../../public/projects/kasturi/projectsix/gallery/3.webp";
import gallery4projectsix from "../../../../public/projects/kasturi/projectsix/gallery/4.webp";
import gallery5projectsix from "../../../../public/projects/kasturi/projectsix/gallery/5.webp";

// projectseven
import overviewImageprojectseven from "../../../../public/projects/kasturi/projectseven/overview/1.webp";
import bannerDesktopImageprojectseven from "../../../../public/projects/kasturi/projectseven/banner/1.webp";
import bannerMobileImageprojectseven from "../../../../public/projects/kasturi/projectseven/banner/2.webp";
import Locationprojectseven from "../../../../public/projects/kasturi/projectseven/location/1.webp";
import Hightlightsprojectseven from "../../../../public/projects/kasturi/projectseven/highlights/1.webp";
import floorplan1projectseven from "../../../../public/projects/kasturi/projectseven/floorplan/1.webp";
import floorplan2projectseven from "../../../../public/projects/kasturi/projectseven/floorplan/2.webp";
import floorplan3projectseven from "../../../../public/projects/kasturi/projectseven/floorplan/3.webp";
import floorplan4projectseven from "../../../../public/projects/kasturi/projectseven/floorplan/4.webp";
import floorplan5projectseven from "../../../../public/projects/kasturi/projectseven/floorplan/5.webp";
import locationiconprojectseven from "../../../../public/projects/kasturi/projectseven/overview/l.png";
import caliconprojectseven from "../../../../public/projects/kasturi/projectseven/overview/c.png";
import newlaunchiconprojectseven from "../../../../public/projects/kasturi/projectseven/overview/n.png";
import gallery1projectseven from "../../../../public/projects/kasturi/projectseven/gallery/1.webp";
import gallery2projectseven from "../../../../public/projects/kasturi/projectseven/gallery/2.webp";
import gallery3projectseven from "../../../../public/projects/kasturi/projectseven/gallery/3.webp";
import gallery4projectseven from "../../../../public/projects/kasturi/projectseven/gallery/4.webp";
import gallery5projectseven from "../../../../public/projects/kasturi/projectseven/gallery/5.webp";

// projecteight
import overviewImageprojecteight from "../../../../public/projects/kasturi/projecteight/overview/1.webp";
import bannerDesktopImageprojecteight from "../../../../public/projects/kasturi/projecteight/banner/1.webp";
import bannerMobileImageprojecteight from "../../../../public/projects/kasturi/projecteight/banner/2.webp";
import Locationprojecteight from "../../../../public/projects/kasturi/projecteight/location/1.webp";
import Hightlightsprojecteight from "../../../../public/projects/kasturi/projecteight/highlights/1.webp";
import floorplan1projecteight from "../../../../public/projects/kasturi/projecteight/floorplan/1.webp";
import floorplan2projecteight from "../../../../public/projects/kasturi/projecteight/floorplan/2.webp";
import floorplan3projecteight from "../../../../public/projects/kasturi/projecteight/floorplan/3.webp";
import floorplan4projecteight from "../../../../public/projects/kasturi/projecteight/floorplan/4.webp";
import floorplan5projecteight from "../../../../public/projects/kasturi/projecteight/floorplan/5.webp";
import locationiconprojecteight from "../../../../public/projects/kasturi/projecteight/overview/l.png";
import caliconprojecteight from "../../../../public/projects/kasturi/projecteight/overview/c.png";
import newlaunchiconprojecteight from "../../../../public/projects/kasturi/projecteight/overview/n.png";
import gallery1projecteight from "../../../../public/projects/kasturi/projecteight/gallery/1.webp";
import gallery2projecteight from "../../../../public/projects/kasturi/projecteight/gallery/2.webp";
import gallery3projecteight from "../../../../public/projects/kasturi/projecteight/gallery/3.webp";
import gallery4projecteight from "../../../../public/projects/kasturi/projecteight/gallery/4.webp";
import gallery5projecteight from "../../../../public/projects/kasturi/projecteight/gallery/5.webp";

// projectnine
import overviewImageprojectnine from "../../../../public/projects/kasturi/projectnine/overview/1.webp";
import bannerDesktopImageprojectnine from "../../../../public/projects/kasturi/projectnine/banner/1.webp";
import bannerMobileImageprojectnine from "../../../../public/projects/kasturi/projectnine/banner/2.webp";
import Locationprojectnine from "../../../../public/projects/kasturi/projectnine/location/1.webp";
import Hightlightsprojectnine from "../../../../public/projects/kasturi/projectnine/highlights/1.webp";
import floorplan1projectnine from "../../../../public/projects/kasturi/projectnine/floorplan/1.webp";
import floorplan2projectnine from "../../../../public/projects/kasturi/projectnine/floorplan/2.webp";
import floorplan3projectnine from "../../../../public/projects/kasturi/projectnine/floorplan/3.webp";
import floorplan4projectnine from "../../../../public/projects/kasturi/projectnine/floorplan/4.webp";
import floorplan5projectnine from "../../../../public/projects/kasturi/projectnine/floorplan/5.webp";
import locationiconprojectnine from "../../../../public/projects/kasturi/projectnine/overview/l.png";
import caliconprojectnine from "../../../../public/projects/kasturi/projectnine/overview/c.png";
import newlaunchiconprojectnine from "../../../../public/projects/kasturi/projectnine/overview/n.png";
import gallery1projectnine from "../../../../public/projects/kasturi/projectnine/gallery/1.webp";
import gallery2projectnine from "../../../../public/projects/kasturi/projectnine/gallery/2.webp";
import gallery3projectnine from "../../../../public/projects/kasturi/projectnine/gallery/3.webp";
import gallery4projectnine from "../../../../public/projects/kasturi/projectnine/gallery/4.webp";
import gallery5projectnine from "../../../../public/projects/kasturi/projectnine/gallery/5.webp";

// projectten
import overviewImageprojectten from "../../../../public/projects/kasturi/projectten/overview/1.webp";
import bannerDesktopImageprojectten from "../../../../public/projects/kasturi/projectten/banner/1.webp";
import bannerMobileImageprojectten from "../../../../public/projects/kasturi/projectten/banner/2.webp";
import Locationprojectten from "../../../../public/projects/kasturi/projectten/location/1.webp";
import Hightlightsprojectten from "../../../../public/projects/kasturi/projectten/highlights/1.webp";
import floorplan1projectten from "../../../../public/projects/kasturi/projectten/floorplan/1.webp";
import floorplan2projectten from "../../../../public/projects/kasturi/projectten/floorplan/2.webp";
import floorplan3projectten from "../../../../public/projects/kasturi/projectten/floorplan/3.webp";
import floorplan4projectten from "../../../../public/projects/kasturi/projectten/floorplan/4.webp";
import floorplan5projectten from "../../../../public/projects/kasturi/projectten/floorplan/5.webp";
import locationiconprojectten from "../../../../public/projects/kasturi/projectten/overview/l.png";
import caliconprojectten from "../../../../public/projects/kasturi/projectten/overview/c.png";
import newlaunchiconprojectten from "../../../../public/projects/kasturi/projectten/overview/n.png";
import gallery1projectten from "../../../../public/projects/kasturi/projectten/gallery/1.webp";
import gallery2projectten from "../../../../public/projects/kasturi/projectten/gallery/2.webp";
import gallery3projectten from "../../../../public/projects/kasturi/projectten/gallery/3.webp";
import gallery4projectten from "../../../../public/projects/kasturi/projectten/gallery/4.webp";
import gallery5projectten from "../../../../public/projects/kasturi/projectten/gallery/5.webp";



export const developerkasturi = {
  properties: [
    {
      name: "kasturi The Trillion",
      image: bannerMobileImageeonhomes,
      price: " 6.14 Crore Onwards",
      state: " Gurugram",
      developer: "kasturi",
      location: "Sector 48, Gurugram",
      projectlocation: "Gurugram",
      bed: "3,4 BHK Apartments",
      size: "3000-3600 sq.ft.",
      url: `/kasturi-trillion`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "kasturi The Trillion",
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};
export const Headers = {
  logo: s,
  data: {
    experience: "2006",
  },
  about: `kasturi, a 100% FDI funded real-estate developer, backed by kasturi Holdings Pte. Ltd., Singapore, the real estate investing division of the AT Holdings group of companies. AT Capital, headquartered in Singapore, was established with the aim of capitalizing on global opportunities within both established and emerging sectors.`,
};


export const projectskasturi = {

  eonhomes: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageeonhomes,
      bannerMobileImage: bannerMobileImageeonhomes,
      textOverlay: "",
      data: {
        title: "Kasturi Eon Homes",
        subtitle: " Phase 3 Hinjewadi, Pune",
        starting_price: "₹ 69.56 L - 1.54 Cr   ",
        payment_plan: "CLP",
        rerano: "-",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Kasturi Eon Homes Phase 3 Hinjewadi, Pune",
      description: [
        "Kasturi Eon Homes Phase 3 in Hinjewadi, Pune offers modern living for people looking for a good mix of luxury, convenience, and connection. It is located in the city’s IT area, making it a great choice for those wanting 2 BHK flats. The project is noted for its modern design, quality features, and closeness to major workplaces, making it a good option for both professionals and families.",
        "There is a high demand for flats in Pune Hinjewadi because of the area’s fast growth and good facilities. These apartments provide a lively lifestyle with easy access to schools, hospitals, shops, and places for fun. Kasturi Eon Homes Phase 3 adds to this with well-designed living spaces, gardens, and modern recreational facilities for a comfortable life.",
        "If you are looking for 2 BHK flats in Pune Hinjewadi, there are many choices for different tastes and budgets. Prices usually range from ₹48 lakhs to ₹85 lakhs, depending on the project and its features. Kasturi Eon Homes Phase 3 is especially appealing because it is near major IT parks and business areas, which helps reduce travel time and improve work-life balance.",
        "Flats in Pune Hinjewadi are known for their spacious layouts, modern interiors, and safe communities. Many projects, including Kasturi Eon Homes Phase 3, offer amenities like a clubhouse, swimming pool, gym, children's play area, and 24/7 security, making them popular for families and young workers. The area’s good transport links make it easy to travel around Pune.",
      ],
      keywordLinks: {
      },
      image: overviewImageeonhomes,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconeonhomes,
          title: "₹ 69.56 L Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconeonhomes,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconeonhomes,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK ",
          area: "794.48 - 935 sq.ft. ",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK  ",
          area: "944.64 - 1282 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "2 BHK ",
        area: "794.48 - 935 sq.ft. ",
        price: "₹ 6.14 Cr",
        image: floorplan1eonhomes,
      },
      {
        type: "3 BHK  ",
        area: "944.64 - 1282 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2eonhomes,
      }
    ],

    highlights: {
      images: Hightlightseonhomes,
      tagline: "Highlights",
      features: [
        "Award-winning project in Asia Pacific for property.  ",
        "Ramps for people with disabilities with Braille buttons and signs in elevators and stairs.  ",
        "Kasturi homecare is a team that takes care of the apartments regularly. ",
        "The project is near Balewadi Stadium.  ",
        "The home has air conditioning. ",
      ],
    },

    location: {
      image: Locationeonhomes,
      data: [
        {
          airport: {
            distance_time: "29.4 km",
            name: "Pune International Airport"
          },
          school: {
            distance_time: "1.9 Km",
            name: "Amrita Vidyalayam "
          },
          railwayormetro: {
            distance_time: "15.4 Km",
            name: "Chinchwad Junction "
          },
          hospital: {
            distance_time: "6.8 Km",
            name: "Sanjeevani Multispeciality Hospital "
          },
          mall: {
            distance_time: "7.3 Km",
            name: "Xion Mall "
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1eonhomes },
        { image: gallery2eonhomes },
        { image: gallery3eonhomes },
        { image: gallery4eonhomes },
        { image: gallery5eonhomes },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in kasturi The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "What is the possession timeline for Kasturi Eon Homes Phase 3?",
        answer: `Possession for the apartments is expected by December 2026.`,
      },
      {
        question: "What types of residences are available at Kasturi Eon Homes Phase 3?",
        answer: `The project offers 2 BHK, 2.5 BHK, and 3 BHK apartments.`,
      },
      {
        question: "What are the key amenities offered at Kasturi Eon Homes Phase 3?",
        answer: `Residents enjoy a clubhouse, swimming pool with kids' pool, fully equipped gym, aerobics room, squash and badminton courts, billiards room, co-working space with Wi-Fi, community coffee shop, and more.`,
      },
      {
        question: "Is Kasturi Eon Homes Phase 3 a gated community?",
        answer: `Yes, it is a gated community with multi-layered security, including CCTV surveillance and ramps for specially-abled individuals.`,
      },
      {
        question: "How much open space does the project provide?",
        answer: `Kasturi Eon Homes Phase 3 features approximately 60% open spaces, including landscaped gardens and green areas.`,
      },
      {
        question: "What is the starting price for 2 BHK and 3 BHK flats?",
        answer: `The price for a 2 BHK flat starts at approximately ₹83.1 lakh, while 3 BHK flats are priced around ₹1.13 crore.`,
      },
      {
        question: "How is Kasturi Eon Homes Phase 3 connected to the rest of Pune?",
        answer: `The project is well-connected via the Mumbai-Pune Expressway and Pune-Bangalore Highway, and is located near Tech Mahindra in Hinjewadi Phase 3.`,
      },
      {
        question: "Who is the developer behind Kasturi Eon Homes Phase 3?",
        answer: `Kasturi Eon Homes Phase 3 is developed by Kasturi Housing.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Kasturi Eon Homes Phase 3 is RERA registered with registration numbers including P52100026429, P52100046679, P52100055358, P52100024680, P52100030732, and P52100048176.`,
      },
      {
        question: "Are there any special lifestyle features?",
        answer: `Unique features include a community coffee shop, co-working space with Wi-Fi, and air-conditioned bedrooms.`,
      }
    ],
    

    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projecttwo: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecttwo,
      bannerMobileImage: bannerMobileImageprojecttwo,
      textOverlay: "",
      data: {
        title: "kasturi The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "kasturi The Trillion",
      description: [
        "kasturi The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by kasturi Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at kasturi Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at kasturi Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of kasturi The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "kasturi": "/developers/kasturi",
      },
      image: overviewImageprojecttwo,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecttwo,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecttwo,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecttwo,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecttwo,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecttwo,
      }
    ],

    highlights: {
      images: Hightlightsprojecttwo,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecttwo,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecttwo },
        { image: gallery2projecttwo },
        { image: gallery3projecttwo },
        { image: gallery4projecttwo },
        { image: gallery5projecttwo },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in kasturi The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is kasturi The Trillion located?",
        answer: `kasturi The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at kasturi The Trillion?",
        answer: `kasturi The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in kasturi The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at kasturi The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, kasturi The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of kasturi The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at kasturi The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of kasturi The Trillion?",
        answer: `kasturi The Trillion is developed by kasturi Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is kasturi The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, kasturi The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from kasturi The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectthree: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectthree,
      bannerMobileImage: bannerMobileImageprojectthree,
      textOverlay: "",
      data: {
        title: "kasturi The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "kasturi The Trillion",
      description: [
        "kasturi The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by kasturi Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at kasturi Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at kasturi Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of kasturi The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "kasturi": "/developers/kasturi",
      },
      image: overviewImageprojectthree,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectthree,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectthree,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectthree,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectthree,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectthree,
      }
    ],

    highlights: {
      images: Hightlightsprojectthree,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectthree,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectthree },
        { image: gallery2projectthree },
        { image: gallery3projectthree },
        { image: gallery4projectthree },
        { image: gallery5projectthree },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in kasturi The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is kasturi The Trillion located?",
        answer: `kasturi The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at kasturi The Trillion?",
        answer: `kasturi The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in kasturi The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at kasturi The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, kasturi The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of kasturi The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at kasturi The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of kasturi The Trillion?",
        answer: `kasturi The Trillion is developed by kasturi Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is kasturi The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, kasturi The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from kasturi The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfour: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfour,
      bannerMobileImage: bannerMobileImageprojectfour,
      textOverlay: "",
      data: {
        title: "kasturi The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "kasturi The Trillion",
      description: [
        "kasturi The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by kasturi Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at kasturi Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at kasturi Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of kasturi The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "kasturi": "/developers/kasturi",
      },
      image: overviewImageprojectfour,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfour,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfour,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfour,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfour,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfour,
      }
    ],

    highlights: {
      images: Hightlightsprojectfour,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfour,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfour },
        { image: gallery2projectfour },
        { image: gallery3projectfour },
        { image: gallery4projectfour },
        { image: gallery5projectfour },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in kasturi The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is kasturi The Trillion located?",
        answer: `kasturi The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at kasturi The Trillion?",
        answer: `kasturi The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in kasturi The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at kasturi The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, kasturi The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of kasturi The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at kasturi The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of kasturi The Trillion?",
        answer: `kasturi The Trillion is developed by kasturi Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is kasturi The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, kasturi The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from kasturi The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfive: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfive,
      bannerMobileImage: bannerMobileImageprojectfive,
      textOverlay: "",
      data: {
        title: "kasturi The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "kasturi The Trillion",
      description: [
        "kasturi The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by kasturi Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at kasturi Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at kasturi Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of kasturi The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "kasturi": "/developers/kasturi",
      },
      image: overviewImageprojectfive,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfive,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfive,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfive,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfive,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfive,
      }
    ],

    highlights: {
      images: Hightlightsprojectfive,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfive,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfive },
        { image: gallery2projectfive },
        { image: gallery3projectfive },
        { image: gallery4projectfive },
        { image: gallery5projectfive },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in kasturi The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is kasturi The Trillion located?",
        answer: `kasturi The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at kasturi The Trillion?",
        answer: `kasturi The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in kasturi The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at kasturi The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, kasturi The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of kasturi The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at kasturi The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of kasturi The Trillion?",
        answer: `kasturi The Trillion is developed by kasturi Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is kasturi The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, kasturi The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from kasturi The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectsix: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectsix,
      bannerMobileImage: bannerMobileImageprojectsix,
      textOverlay: "",
      data: {
        title: "kasturi The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "kasturi The Trillion",
      description: [
        "kasturi The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by kasturi Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at kasturi Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at kasturi Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of kasturi The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "kasturi": "/developers/kasturi",
      },
      image: overviewImageprojectsix,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectsix,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectsix,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectsix,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectsix,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectsix,
      }
    ],

    highlights: {
      images: Hightlightsprojectsix,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectsix,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectsix },
        { image: gallery2projectsix },
        { image: gallery3projectsix },
        { image: gallery4projectsix },
        { image: gallery5projectsix },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in kasturi The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is kasturi The Trillion located?",
        answer: `kasturi The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at kasturi The Trillion?",
        answer: `kasturi The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in kasturi The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at kasturi The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, kasturi The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of kasturi The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at kasturi The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of kasturi The Trillion?",
        answer: `kasturi The Trillion is developed by kasturi Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is kasturi The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, kasturi The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from kasturi The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectseven: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectseven,
      bannerMobileImage: bannerMobileImageprojectseven,
      textOverlay: "",
      data: {
        title: "kasturi The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "kasturi The Trillion",
      description: [
        "kasturi The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by kasturi Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at kasturi Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at kasturi Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of kasturi The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "kasturi": "/developers/kasturi",
      },
      image: overviewImageprojectseven,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectseven,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectseven,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectseven,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectseven,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectseven,
      }
    ],

    highlights: {
      images: Hightlightsprojectseven,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectseven,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectseven },
        { image: gallery2projectseven },
        { image: gallery3projectseven },
        { image: gallery4projectseven },
        { image: gallery5projectseven },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in kasturi The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is kasturi The Trillion located?",
        answer: `kasturi The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at kasturi The Trillion?",
        answer: `kasturi The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in kasturi The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at kasturi The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, kasturi The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of kasturi The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at kasturi The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of kasturi The Trillion?",
        answer: `kasturi The Trillion is developed by kasturi Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is kasturi The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, kasturi The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from kasturi The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projecteight: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecteight,
      bannerMobileImage: bannerMobileImageprojecteight,
      textOverlay: "",
      data: {
        title: "kasturi The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "kasturi The Trillion",
      description: [
        "kasturi The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by kasturi Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at kasturi Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at kasturi Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of kasturi The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "kasturi": "/developers/kasturi",
      },
      image: overviewImageprojecteight,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecteight,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecteight,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecteight,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecteight,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecteight,
      }
    ],

    highlights: {
      images: Hightlightsprojecteight,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecteight,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecteight },
        { image: gallery2projecteight },
        { image: gallery3projecteight },
        { image: gallery4projecteight },
        { image: gallery5projecteight },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in kasturi The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is kasturi The Trillion located?",
        answer: `kasturi The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at kasturi The Trillion?",
        answer: `kasturi The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in kasturi The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at kasturi The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, kasturi The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of kasturi The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at kasturi The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of kasturi The Trillion?",
        answer: `kasturi The Trillion is developed by kasturi Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is kasturi The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, kasturi The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from kasturi The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectnine: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectnine,
      bannerMobileImage: bannerMobileImageprojectnine,
      textOverlay: "",
      data: {
        title: "kasturi The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "kasturi The Trillion",
      description: [
        "kasturi The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by kasturi Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at kasturi Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at kasturi Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of kasturi The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "kasturi": "/developers/kasturi",
      },
      image: overviewImageprojectnine,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectnine,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectnine,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectnine,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectnine,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectnine,
      }
    ],

    highlights: {
      images: Hightlightsprojectnine,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectnine,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectnine },
        { image: gallery2projectnine },
        { image: gallery3projectnine },
        { image: gallery4projectnine },
        { image: gallery5projectnine },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in kasturi The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is kasturi The Trillion located?",
        answer: `kasturi The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at kasturi The Trillion?",
        answer: `kasturi The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in kasturi The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at kasturi The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, kasturi The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of kasturi The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at kasturi The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of kasturi The Trillion?",
        answer: `kasturi The Trillion is developed by kasturi Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is kasturi The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, kasturi The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from kasturi The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectten: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectten,
      bannerMobileImage: bannerMobileImageprojectten,
      textOverlay: "",
      data: {
        title: "kasturi The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "kasturi The Trillion",
      description: [
        "kasturi The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by kasturi Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at kasturi Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at kasturi Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of kasturi The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "kasturi": "/developers/kasturi",
      },
      image: overviewImageprojectten,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectten,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectten,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectten,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectten,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectten,
      }
    ],

    highlights: {
      images: Hightlightsprojectten,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectten,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectten },
        { image: gallery2projectten },
        { image: gallery3projectten },
        { image: gallery4projectten },
        { image: gallery5projectten },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in kasturi The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is kasturi The Trillion located?",
        answer: `kasturi The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at kasturi The Trillion?",
        answer: `kasturi The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in kasturi The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at kasturi The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, kasturi The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of kasturi The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at kasturi The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of kasturi The Trillion?",
        answer: `kasturi The Trillion is developed by kasturi Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is kasturi The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, kasturi The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from kasturi The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
};
